export const FIELD_NAMES = {
    PDP: 'pdp',
    MARKETPLACE: 'marketplace'
};
